import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Check } from 'lucide-react';
import { programs } from '../mock';

export const Programs = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="programs" className="py-20 px-4 bg-gradient-to-b from-white to-[#f0f9ff]">
      <div className="container mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a5f] mb-4">
            Our Training Programs
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the program that fits your career goals. All programs include comprehensive training, certification, and job placement assistance.
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {programs.map((program, index) => (
            <Card 
              key={program.id}
              className={`relative overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 ${
                index === 0 ? 'border-[#d97706] border-2' : ''
              }`}
            >
              {index === 0 && (
                <div className="absolute top-0 right-0 bg-[#d97706] text-white px-4 py-1 text-sm font-semibold">
                  POPULAR
                </div>
              )}
              
              <CardHeader>
                <Badge className="w-fit mb-2 bg-[#1e3a5f] text-white">{program.subtitle}</Badge>
                <CardTitle className="text-2xl text-[#1e3a5f]">{program.title}</CardTitle>
                <CardDescription className="text-base">{program.description}</CardDescription>
              </CardHeader>
              
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  {program.price && (
                    <div className="flex items-baseline gap-2">
                      <span className="text-4xl font-bold text-[#d97706]">{program.price}</span>
                      {program.price !== 'Contact Us' && <span className="text-gray-500">total</span>}
                    </div>
                  )}
                  <div className="text-sm text-gray-600">Duration: {program.duration}</div>
                </div>

                <div className="space-y-3 pt-4 border-t">
                  {program.features.map((feature) => (
                    <div key={feature} className="flex items-start gap-2">
                      <Check className="w-5 h-5 text-[#d97706] flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
              
              <CardFooter>
                <Button 
                  onClick={scrollToContact}
                  className={`w-full ${
                    index === 0 
                      ? 'bg-[#d97706] hover:bg-[#b45309] text-white' 
                      : 'bg-[#1e3a5f] hover:bg-[#152940] text-white'
                  }`}
                >
                  Enroll Now
                </Button>
              </CardFooter>
            </Card>
          ))}
        </div>

        {/* CLIMB Financing */}
        <div className="mt-12 text-center">
          <a
            href="https://www.climbcredit.com/apply/diamondtrucking"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="climb-financing-btn"
            className="inline-block bg-[#d97706] hover:bg-[#b45309] text-white text-xl font-bold px-10 py-5 rounded-lg shadow-lg hover:shadow-xl transition-all"
          >
            CLIMB Financing Available
          </a>
          <p className="mt-4 text-lg text-gray-600 font-medium">
            Application Takes Less Than 5-Minutes to Get Qualified
          </p>
        </div>

        {/* What to Expect Section */}
        <div className="mt-20 bg-white p-8 md:p-12 rounded-2xl shadow-lg">
          <h3 className="text-3xl font-bold text-[#1e3a5f] mb-6 text-center">
            What to Expect From Us
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed max-w-4xl mx-auto text-center">
            Diamond Trucking School will teach and guide you to become a trucker who practices safety first and defensive driving. You'll learn to handle your rig with expert driving skills in all weather conditions - from rain to snow, from mountains to countryside, from city streets to downtown traffic. You'll become comfortable behind the wheel and feel at ease when you're out on the road.
          </p>
        </div>
      </div>
    </section>
  );
};